import React from "react";
import AntInput, { InputProps } from "antd/lib/input";

import "./input.less";

export const Input = (props: InputProps) => <AntInput {...props} />;
export const { Search } = AntInput;
export type { InputProps };
